/**
 * Ported from the server package.
 */

/**
 * The canonical model names.
 *
 * Depending on when the robot was manufactured and other conditions, the
 * actual model number may use different suffixes, like UR10, UR10e, UR8_LONG.
 *
 * Use `getModelNumbers` to get the possible model numbers.
 * Use `getModelByNumber` to get the canonical model name from a number.
 * Use `isModelNumber` to check if a number is a valid model number.
 */
export enum URModel {
  UR5 = 'UR5',
  UR8_LONG = 'UR8_LONG', // UR7_LONG is an early prototype of this model
  UR10 = 'UR10',
  UR20 = 'UR20',
}

/**
 * The equivalent model numbers for each model.
 * Universal Robot model numbers typically are "UR#" where # refers to
 * the payload capacity of the robot arm.
 *
 * Older models known as the CB-series use the "UR#" format.
 * Newer models known as the E-series use the "UR#e" format.
 * They are effectively the same robot arm but with different controller software.
 *
 * The UR7_LONG and UR8_LONG models are special cases.
 * The UR7_LONG is an early prototype of the UR8_LONG.
 * They are distinct from their non-long-suffixed counterparts in that their
 * arms are longer like a UR20. Don't know why the UR20 doesn't have _LONG suffix.
 * Anyways, Universal Robots has told us that the `_LONG` suffix should be
 * treated distinct from the CB-series and E-series models.
 */
export const URModelNumbers: Record<URModel, Array<string>> = {
  [URModel.UR5]: ['UR5', 'UR5e'],
  [URModel.UR8_LONG]: ['UR7_LONG', 'UR8_LONG'],
  [URModel.UR10]: ['UR10', 'UR10e'],
  [URModel.UR20]: ['UR20', 'UR20e'],
};
